
// LETS DEPRICATE THIS, use tailwind instead
export default {
    name: 'Clearspace',
    props: {
        size: {
            type: Number,
            default: 5,
            validator: function (value) {
                // using $vr available sizes
                return [...Array(12).keys()].includes(value)
            },
        },
        touch: {
            type: Number,
            default: 0,
            validator: function (value) {
                // using $vr available sizes
                return [...Array(12).keys()].includes(value)
            },
        },
        mobile: {
            type: Number,
            default: 0,
            validator: function (value) {
                // using $vr available sizes
                return [...Array(12).keys()].includes(value)
            },
        },
    },
    computed: {
        touchClass() {
            return this.touch > 0 ? `clearspace-touch--${this.touch}` : ''
        },
        mobileClass() {
            return this.mobile > 0 ? `clearspace-mobile--${this.mobile}` : ''
        },
    },
}
